import React from 'react';
import { getPathToTypeList } from '../../utils/listBodyUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

import './LinksAndCurrentLocation.css';
import { getTranslation } from '../../assets/creator/translations';

const getRoutes = () => (getPathToTypeList().map(route => (
    {
        title: getTranslation(route.pageTranslationKey),
        to: route.path,
        index: route.index,
        listName: route.listName
    }
)))

const GetLinks = () => {
    const allLinks = getRoutes();
    const location = allLinks.find((link) => { if (link.to === window.location.pathname) return link; return null })
    const activeNavLink = location ? location.index : 0;

    return {
        allLinks: allLinks,
        activeNavLink: activeNavLink,

    };
}

const LinksAndCurrentLocation = () => {
    let { allLinks, activeNavLink } = GetLinks();
    return (
        <div
            className="pages-dropdown"
        >
            <div className="pages-dropdown__current-page">
                <div className="pages-dropdown__current-page-title">
                    <span>{allLinks[activeNavLink].title}</span>
                </div>
                <FontAwesomeIcon icon={faCaretDown} />
            </div>
        </div>
    );
}

export default LinksAndCurrentLocation;
export { GetLinks };



// WEBPACK FOOTER //
// ./src/components/LinksAndCurrentLocation/LinksAndCurrentLocation.js